import { render } from "./VjsPlayer.vue?vue&type=template&id=1ea6704a"
import script from "./VjsPlayer.vue?vue&type=script&lang=js"
export * from "./VjsPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/home/drusso/rds-workspace/it-rds-active/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__